import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { IoCloseCircleOutline } from "react-icons/io5";
import * as s from "./index.module.scss";
import Popups from "../../../components/Common/Popups";
import { PrismicRichText } from "@prismicio/react";
import secondaryFont from "@/utils/secondaryFont";

const WatchPopups = ({ show, onHide, dataID, watcheDetail }) => {
  const [showSellModal, setShowSellModal] = useState(false);

  let watch_description = "";
  let watch_image = "";
  let watches = [];
  let brand = "";
  let watch_name = "";
  let watch_brand = "";
  let desc_title = "";

  watcheDetail.map((item, data, idx) => {
    if (item.uid === dataID) {
      watch_description = item?.data?.watch_description;
      watch_image = item?.data?.watch_image;
      watch_name = item?.data?.watch_name;
      watch_brand = item?.data?.watch_brand;
      brand = item?.data?.brand;
      desc_title = item?.data?.description_title;
    }
  });

  return (
    <section className={`${s.modals} section_detail`}>
      <Modal
        show={show}
        onHide={onHide}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body className={s.model_box}>
          <div className={s.outer_box}>
            <div className={s.desc}>
              <h4 className="fw-bold">{desc_title}</h4>
              <div className={`${secondaryFont}`}>
                <PrismicRichText field={watch_description || []} />
              </div>
            </div>
            <div className={s.carousel_box}>
              <div className={s.carouel_img}>
                <div className={s.watchImg}>
                  <img
                    loading="lazy"
                    src={watch_image.url}
                    alt={watch_image.alt || "image"}
                    height="100%"
                  />
                </div>
              </div>
              {/* <img loading="lazy" src={BG.src} /> */}
              <div className={s.brand}>
                <h5 className="fw-bold">{watch_name}</h5>
                <h6 className="mb-3 pb-1">{watch_brand}</h6>
                <button
                  className={`btn btn-primary m-auto w-auto  ${s.button_sell}`}
                  onClick={() => {
                    setShowSellModal(true);
                  }}
                >
                  Sell Now
                </button>
              </div>
            </div>
          </div>
          <div className={s.bootom_img}>
            <img
              loading="lazy"
              src={brand?.url}
              alt={brand?.alt || "image"}
              height="100%"
            />
          </div>
          <div className={s.close_button}>
            <button onClick={onHide}>
              <IoCloseCircleOutline size="48px" />
            </button>
          </div>
        </Modal.Body>
      </Modal>
      <Popups
        show={showSellModal}
        onHide={() => {
          setShowSellModal(false);
        }}
      />
    </section>
  );
};
export default WatchPopups;
